// projects/humanresources-general/src/assets/i18n/*/hr-gen-hrm-detail.json
export class HrGenHrmDetailKey {
    private static readonly keyPrefix = 'hrGenHrmDetail';
    public static pageHeader = `${HrGenHrmDetailKey.keyPrefix}.pageHeader`;
    public static locale = `${HrGenHrmDetailKey.keyPrefix}.locale`;
    public static tableName = `${HrGenHrmDetailKey.keyPrefix}.tableName`;
    public static timeConstraint = `${HrGenHrmDetailKey.keyPrefix}.timeConstraint`;
    public static typeIndicator = `${HrGenHrmDetailKey.keyPrefix}.typeIndicator`;
}
